import { setupListeners } from "@reduxjs/toolkit/dist/query";
import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";
import adbSlice from "./slice/dashboard";
import procurementSlice from "./slice/procurement";
import mfaSlice from "./slice/mfAuth";
import forgetSlice from "./slice/forgetSlice";
import statisticSlice from "./slice/statistic";
import { adbApi } from "./service/adbService";
import quarterlySlice from "./slice/quarterly.slice";

import { authApi } from "./service/authApi";

export const store = configureStore({
  reducer: {
    [authApi.reducerPath]: authApi.reducer,
    adbReducer: adbSlice,
    mfaReducer: mfaSlice,
    forgetReducer: forgetSlice,
    statisticReducer: statisticSlice,
    quarterlyReducer: quarterlySlice,
    procurementReducer: procurementSlice,
    [adbApi.reducerPath]: adbApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({serializableCheck: false}).concat(adbApi.middleware, authApi.middleware),
});

setupListeners(store.dispatch);
